import React from 'react';
import classnames from 'classnames';
import { EtchWidgets } from '@thd-olt-component-react/etch-widgets';
import {
  arrayOf, bool, shape, string
} from 'prop-types';
import { Col, Row } from '@thd-olt-component-react/grid';
import { SponsoredProductListing } from '@thd-olt-component-react/sponsored-content';
import { BulletList } from '../BulletList/BulletList';
import { InfoGuides } from '../InfoGuides/InfoGuides';

import { RevJet } from '../RevJet/RevJet';

import './desktop-content.scss';

const DesktopContent = (props) => {
  const {
    itemId,
    channel,
    description,
    documents,
    richContent,
    hideRichContents,
    preview,
    bullets,
    shouldShowMore,
    showRichContentsOnly,
    returnMessage,
    showReturnMessage,
    showPla
  } = props;

  const DISPLAY_MODE_REVJET = 'revjet';
  const DISPLAY_MODE_ETCH = 'display rich content';

  const desktopContentClasses = classnames({
    'desktop-content-wrapper--show-less': shouldShowMore
  });

  const etchContent = richContent?.content;
  const displayMode = typeof richContent?.displayMode === 'string'
    ? richContent?.displayMode.toLowerCase() : richContent?.displayMode;
  const revJet = displayMode === DISPLAY_MODE_REVJET;
  const etch = !!displayMode
    && displayMode.startsWith(DISPLAY_MODE_ETCH);
  const displayInfoAndGuides = !!((documents || []).length && !showRichContentsOnly);

  // TODO: Clean this up, bad pattern.
  const thdGlobalDefined = typeof window !== 'undefined'
   && typeof window.THD_GLOBAL !== 'undefined'
   && window.THD_GLOBAL;
  const env = thdGlobalDefined.API_PROXY_ENV_NAME === '' ? 'prod' : 'qa';

  return (
    <div className="desktop-content-wrapper">
      {revJet && !hideRichContents
        && <RevJet itemId={itemId} envSpace={env} parentId="revJet-desktop-wrapper" />}
      <Row className={desktopContentClasses}>
        {etch && !hideRichContents
          && <EtchWidgets content={etchContent} /> }
        <Col fallback={displayInfoAndGuides ? '7' : '12'} className="desktop-content-wrapper__left-col">
          <Row className="desktop-content-wrapper__main-description">
            {!showRichContentsOnly ? description : null}
            {bullets && bullets.length
              && <BulletList bullets={bullets} margin isMobile={false} />}
          </Row>
        </Col>
        {displayInfoAndGuides && (
          <Col fallback="5">
            <InfoGuides
              documents={documents}
              channel={channel}
              returnMessage={returnMessage}
              showReturnMessage={showReturnMessage}
            />
            {showPla && (
              <div className="sponsored-pla-product-overview-wrapper">
                <SponsoredProductListing
                  pageContext={
                    {
                      label: 'product-overview',
                      data: { itemId }
                    }
                  }
                />
              </div>
            )}
          </Col>
        )}
      </Row>
    </div>
  );
};

const areEqual = (prevProps, nextProps) => {
  return prevProps.itemId === nextProps.itemId
  && prevProps.returnMessage === nextProps.returnMessage;
};

DesktopContent.displayName = 'DesktopContent';

DesktopContent.propTypes = {
  channel: string.isRequired,
  description: string.isRequired,
  documents: arrayOf(shape({
    name: string.isRequired,
    url: string.isRequired
  })).isRequired,
  hideRichContents: bool,
  preview: bool,
  richContent: shape({
    content: string,
    displayMode: string,
    url: string
  }),
  bullets: arrayOf(shape({})),
  shouldShowMore: bool,
  showRichContentsOnly: bool,
  returnMessage: string,
  showReturnMessage: bool,
  itemId: string.isRequired,
  showPla: bool
};

DesktopContent.defaultProps = {
  hideRichContents: false,
  preview: false,
  richContent: {},
  shouldShowMore: false,
  showRichContentsOnly: false,
  bullets: [],
  returnMessage: '',
  showReturnMessage: false,
  showPla: false
};

export default React.memo(DesktopContent, areEqual);
